var _namedview, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _g, _g2, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFefco201Template = function SvgFefco201Template(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360.0mm",
    height: "180.5mm",
    viewBox: "0.0 9.5 360.0 180.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 118,
    y1: 20,
    y2: 20,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    x2: 118,
    y1: 20,
    y2: 49,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    x2: 120,
    y1: 49,
    y2: 50,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 122,
    x2: 120,
    y1: 49,
    y2: 50,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 122,
    x2: 122,
    y1: 49,
    y2: 20,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 122,
    x2: 178,
    y1: 20,
    y2: 20,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 178,
    x2: 178,
    y1: 20,
    y2: 49,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 178,
    x2: 180,
    y1: 49,
    y2: 50,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    x2: 180,
    y1: 49,
    y2: 50,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    x2: 182,
    y1: 49,
    y2: 20,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    x2: 278,
    y1: 20,
    y2: 20,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    x2: 278,
    y1: 20,
    y2: 49,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    x2: 280,
    y1: 49,
    y2: 50,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 282,
    x2: 280,
    y1: 49,
    y2: 50,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 282,
    x2: 282,
    y1: 49,
    y2: 20,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 282,
    x2: 340,
    y1: 20,
    y2: 20,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 340,
    x2: 340,
    y1: 20,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 282,
    x2: 340,
    y1: 180,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 282,
    x2: 282,
    y1: 151,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 280,
    x2: 282,
    y1: 150,
    y2: 151,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    x2: 280,
    y1: 151,
    y2: 150,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    x2: 278,
    y1: 151,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    x2: 278,
    y1: 180,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    x2: 182,
    y1: 151,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    x2: 182,
    y1: 150,
    y2: 151,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 178,
    x2: 180,
    y1: 151,
    y2: 150,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 178,
    x2: 178,
    y1: 151,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 122,
    x2: 178,
    y1: 180,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 122,
    x2: 122,
    y1: 151,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 122,
    y1: 150,
    y2: 151,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    x2: 120,
    y1: 151,
    y2: 150,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    x2: 118,
    y1: 151,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 118,
    y1: 180,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 20,
    y1: 150,
    y2: 180,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 0,
    y1: 150,
    y2: 148,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 148,
    y2: 52,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 20,
    y1: 52,
    y2: 50,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 20,
    y1: 50,
    y2: 20,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 120,
    y1: 50,
    y2: 50,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 180,
    y1: 50,
    y2: 50,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    x2: 280,
    y1: 50,
    y2: 50,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 280,
    x2: 340,
    y1: 50,
    y2: 50,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 280,
    x2: 340,
    y1: 150,
    y2: 150,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    x2: 280,
    y1: 150,
    y2: 150,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 180,
    y1: 150,
    y2: 150,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 120,
    y1: 150,
    y2: 150,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 20,
    y1: 50,
    y2: 150,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 120,
    y1: 50,
    y2: 150,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    x2: 180,
    y1: 50,
    y2: 150,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 280,
    x2: 280,
    y1: 50,
    y2: 150,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 345,
    y1: 50,
    y2: 50,
    stroke: "black",
    strokeDasharray: "2 7 10 12",
    strokeWidth: 0.05
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 345,
    y1: 150,
    y2: 150,
    stroke: "black",
    strokeDasharray: "2 7 10 12",
    strokeWidth: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "width"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 120,
    y1: 57.33337,
    y2: 57.33337,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 116,
    y1: 57.33337,
    y2: 56.33337,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 116,
    y1: 57.33337,
    y2: 58.333374,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 24,
    y1: 57.33337,
    y2: 56.33337,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 24,
    y1: 57.33337,
    y2: 58.333374,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 69.231499,
    y: 55.891613,
    fill: "#000",
    strokeWidth: 0.05,
    fontSize: "4px",
    textAnchor: "middle"
  }, "\n            Width\n        "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "depth"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 180,
    y1: 57.33337,
    y2: 57.33337,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    x2: 176,
    y1: 57.33337,
    y2: 56.33337,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    x2: 176,
    y1: 57.33337,
    y2: 58.333374,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 124,
    y1: 57.33337,
    y2: 56.33337,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 124,
    y1: 57.33337,
    y2: 58.333374,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 150.72014,
    y: 55.705532,
    fill: "#000",
    strokeWidth: 0.05,
    fontSize: "4px",
    textAnchor: "middle"
  }, "\n            Depth\n        "))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "height"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 185.70412,
    x2: 185.70412,
    y1: 49.941666,
    y2: 149.94168,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.70412,
    x2: 184.70412,
    y1: 49.941666,
    y2: 53.941666,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.70412,
    x2: 186.70412,
    y1: 49.941666,
    y2: 53.941666,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.70412,
    x2: 184.70412,
    y1: 149.94168,
    y2: 145.94168,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.70412,
    x2: 186.70412,
    y1: 149.94168,
    y2: 145.94168,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -101.94167,
    y: 190.70412,
    fill: "#000",
    fontSize: "4px",
    textAnchor: "middle",
    transform: "rotate(-90)"
  }, "\n            Height\n        "))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFefco201Template, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fefco-201-template.306c7725.svg";
export { ForwardRef as ReactComponent };